import { getHandler } from 'src/utils/fetchHandler';

export const FETCH_OPPORTUNITY_PURPOSES_SUCCEEDED =
	'FETCH_OPPORTUNITY_PURPOSES_SUCCEEDED/OPPORTUNITY_PURPOSES/@WISELY/WEB';
export const FETCH_OPPORTUNITY_PURPOSES_FAILED =
	'FETCH_OPPORTUNITY_PURPOSES_FAILED/OPPORTUNITY_PURPOSES/@WISELY/WEB';

export const fetchOpportunityPurposesSucceeded = payload => ({
	type: FETCH_OPPORTUNITY_PURPOSES_SUCCEEDED,
	payload,
});

export const fetchOpportunityPurposesFailed = payload => ({
	type: FETCH_OPPORTUNITY_PURPOSES_FAILED,
	payload,
});

export const fetchOpportunityPurposes = () => {
	return dispatch => {
		const path = `v2/opportunity_purposes`;

		return getHandler(path)
			.then(json => dispatch(fetchOpportunityPurposesSucceeded(json)))
			.catch(error => {
				console.error('fetchOpportunityPurposes error', error);
				dispatch(fetchOpportunityPurposesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/opportunityPurposes/opportunityPurposes.action.js